import React, { useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";
import { collection, addDoc, serverTimestamp, doc, getDoc } from "firebase/firestore";
import emailjs from "emailjs-com";



function ShareExperiencePage() {
  const [company, setCompany] = useState("");
  const [department, setDepartment] = useState("");
  const [position, setPosition] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [workLocation, setWorkLocation] = useState("");
  const [yearsOnJob, setYearsOnJob] = useState("");
  const [employmentStatus, setEmploymentStatus] = useState("");
  const [comments, setComments] = useState("");
  const [taggedEmails, setTaggedEmails] = useState([]);
  const [customMessage, setCustomMessage] = useState("");
  const [tagInput, setTagInput] = useState("");
  const [showHint, setShowHint] = useState(false);
  const [isLandscapeMobile, setIsLandscapeMobile] = useState(window.innerWidth < 768 && window.innerWidth > window.innerHeight);

  const [ratings, setRatings] = useState({
    management: "",
    coworkers: "",
    supportStaff: "",
    compensation: "",
    benefits: "",
    HR: "",
    overall: "",
  });
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);

  useEffect(() => {
  const handleResize = () => {
    setIsLandscapeMobile(window.innerWidth < 768 && window.innerWidth > window.innerHeight);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);


  useEffect(() => {
    const fetchUserProfile = async () => {
      const user = auth.currentUser;
      if (user) {
        const userRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userRef);
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setCompany(userData.company || "");
          setDepartment(userData.department || "");
          setPosition(userData.position || "");
          setYearsOnJob(userData.yearsOnJob || "");
          setEmploymentStatus(userData.employmentStatus || "");
          setCity(userData.city || "");
          setState(userData.state || "");
          setWorkLocation(userData.workLocation || "");
        }
      }
    };
    fetchUserProfile();
  }, []);

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!auth.currentUser) return console.error("No logged-in user.");

      // ✅ Prevent submitting empty comments
  if (!comments.trim()) {
  alert("Please enter a message before submitting.");
  return;
}

    try {
      const userRef = doc(db, "users", auth.currentUser.uid);
      const userSnap = await getDoc(userRef);
      const userData = userSnap.exists() ? userSnap.data() : {};

      const username = userData.username || "Anonymous";
      const userCity = userData.city || "N/A";
      const userState = userData.state || "N/A";

      const docRef = await addDoc(collection(db, "reviews"), {
        company,
        department,
        position,
        yearsOnJob,
        employmentStatus,
        ratings,
        comments,
        userId: auth.currentUser.uid,
        username,
        city: userCity,
        state: userState,
        workLocation,
        createdAt: serverTimestamp(),
        views: 0,
	likes: 0 
      });

      const preview = comments.substring(0, 200) + "...";
      const postUrl = `${window.location.origin}/post/${docRef.id}`;

      for (let email of taggedEmails) {
        await emailjs.send(
          "service_adwbhlm",
          "template_g9rukrv",
          {
            email,
	    name: "VibeScan Team",
            username,
            company,
            city: userCity,
            state: userState,
            customMessage,
            preview,
            postUrl,
          },
          "fiwBM11ZCGFFnqPqR"
        );
      }

      setSuccess(true);
      setCompany("");
      setDepartment("");
      setPosition("");
      setYearsOnJob("");
      setEmploymentStatus("");
      setComments("");
      setCustomMessage("");
      setTaggedEmails([]);
      setTagInput("");
      setRatings({
        management: "",
        coworkers: "",
        supportStaff: "",
        compensation: "",
        benefits: "",
        hr: "",
        overall: "",
      });
    } catch (err) {
      console.error("❌ Error submitting experience or sending email:", err);
    }
  };

  const handleTagInput = (e) => {
    setTagInput(e.target.value);
  };

  const handleTagKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const emails = tagInput
        .split(/[;,\s]+/)
        .map((email) => email.trim())
        .filter((email) => email && isValidEmail(email) && !taggedEmails.includes(email));
      setTaggedEmails([...taggedEmails, ...emails]);
      setTagInput("");
    }
  };

  const removeEmail = (index) => {
    setTaggedEmails((prev) => prev.filter((_, i) => i !== index));
  };

  return (
<div style={{ position: "relative", minHeight: "100vh" }}>
    
    {/* Logo in top-right */}
   {!isLandscapeMobile && (
  <div style={{ position: "absolute", top: "10px", right: "10px", zIndex: 1 }}>
    <img src="/vibescan-logo.png" alt="Logo" style={{ width: "120px", height: "auto" }} />
  </div>
)}



    <div style={{ maxWidth: "500px", margin: "auto", padding: "20px", textAlign: "left" }}>
      <h2>Share Your Experience</h2>
      {success && <p style={{ color: "green" }}>Experience shared successfully!</p>}

      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "15px" }}>


         <label><b>Company Name:</b></label>
      <input
        type="text"
        value={company}
        onChange={(e) => setCompany(e.target.value)}
        style={{
          background: "transparent",
          border: "none",
          borderBottom: "2px solid #ccc",
          padding: "8px 4px",
          fontSize: "16px",
          outline: "none",
          transition: "border-color 0.3s ease"
        }}
        onFocus={(e) => (e.target.style.borderBottomColor = "#007bff")}
        onBlur={(e) => (e.target.style.borderBottomColor = "#ccc")}
      />


        <label><b>Department:</b></label>
      <input
        type="text"
        value={department}
        onChange={(e) => setDepartment(e.target.value)}
        style={{
          background: "transparent",
          border: "none",
          borderBottom: "2px solid #ccc",
          padding: "8px 4px",
          fontSize: "16px",
          outline: "none",
          transition: "border-color 0.3s ease"
        }}
        onFocus={(e) => (e.target.style.borderBottomColor = "#007bff")}
        onBlur={(e) => (e.target.style.borderBottomColor = "#ccc")}
      />


        <label><b>Position:</b></label>
      <input
        type="text"
        value={position}
        onChange={(e) => setPosition(e.target.value)}
        style={{
          background: "transparent",
          border: "none",
          borderBottom: "2px solid #ccc",
          padding: "8px 4px",
          fontSize: "16px",
          outline: "none",
          transition: "border-color 0.3s ease"
        }}
        onFocus={(e) => (e.target.style.borderBottomColor = "#007bff")}
        onBlur={(e) => (e.target.style.borderBottomColor = "#ccc")}
      />


       <label><b>Years on Job:</b></label>
<select
  value={yearsOnJob}
  onChange={(e) => setYearsOnJob(e.target.value)}
  style={{
    background: "transparent",
    border: "none",
    borderBottom: "2px solid #ccc",
    padding: "8px 4px",
    fontSize: "16px",
    outline: "none",
    transition: "border-color 0.3s ease",
    cursor: "pointer"
  }}
  onFocus={(e) => (e.target.style.borderBottomColor = "#007bff")}
  onBlur={(e) => (e.target.style.borderBottomColor = "#ccc")}
>
  <option value="">Select</option>
  <option value="<1y">Less than 1 year</option>
  <option value="1y-5y">1-5 years</option>
  <option value=">5y">More than 5 years</option>
</select>




        <label><b>Employment Status:</b></label>
<select
  value={employmentStatus}
  onChange={(e) => setEmploymentStatus(e.target.value)}
  style={{
    background: "transparent",
    border: "none",
    borderBottom: "2px solid #ccc",
    padding: "8px 4px",
    fontSize: "16px",
    outline: "none",
    transition: "border-color 0.3s ease",
    cursor: "pointer"
  }}
  onFocus={(e) => (e.target.style.borderBottomColor = "#007bff")}
  onBlur={(e) => (e.target.style.borderBottomColor = "#ccc")}
>
  <option value="">Select</option>
  <option value="Current Employee">Current Employee</option>
  <option value="Former Employee">Former Employee</option>
</select>



        <h3>Rate Your Experience</h3>
        {Object.keys(ratings).map((category) => (
         <div key={category} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  <label style={{ width: "130px" }}>
    {category.charAt(0).toUpperCase() + category.slice(1)}
  </label>
  <select
    value={ratings[category]}
    onChange={(e) => setRatings({ ...ratings, [category]: e.target.value })}
    style={{
      background: "transparent",
      border: "none",
      borderBottom: "2px solid #ccc",
      padding: "8px 4px",
      fontSize: "16px",
      outline: "none",
      transition: "border-color 0.3s ease",
      cursor: "pointer",
      flex: 1
    }}
    onFocus={(e) => (e.target.style.borderBottomColor = "#007bff")}
    onBlur={(e) => (e.target.style.borderBottomColor = "#ccc")}
  >


              <option value="">Select Rating</option>
              <option value="1">1 ★</option>
              <option value="2">2 ★★</option>
              <option value="3">3 ★★★</option>
              <option value="4">4 ★★★★</option>
              <option value="5">5 ★★★★★</option>
              <option value="N/A">N/A</option>
            </select>
          </div>
        ))}


	<label>Comments</label>
<textarea
  value={comments}
  onChange={(e) => setComments(e.target.value)}
  required
  placeholder="Write your experience or feedback here..."
  style={{
    width: "100%",
    minHeight: "120px",
    padding: "10px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    marginBottom: "15px",
    resize: "vertical"
  }}
></textarea>

      <div style={{ position: "relative", marginBottom: "10px" }}>
  <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    Tag Someone via email. <b>Press Enter</b> to confirm
    <span
      style={{
        backgroundColor: "#007bff",
        color: "white",
        borderRadius: "50%",
        width: "18px",
        height: "18px",
        textAlign: "center",
        lineHeight: "18px",
        cursor: "pointer",
        fontSize: "12px"
      }}
      onClick={() => setShowHint((prev) => !prev)}
    >
      ?
    </span>
  </label>

  {showHint && (
    <p style={{ fontSize: "12px", marginTop: "4px", color: "#555" }}>
      Enter the email address of the person or people you’d like to share this post with. They’ll receive a copy of the post along with a link to view and comment on it. Press Enter to confirm each address.
    </p>
  )}

  <input
  type="text"
  className="modern-input"
  value={tagInput}
  onChange={handleTagInput}
  onKeyDown={handleTagKeyDown}
  placeholder="For multiple emails separate with ','"
  style={{
    width: "100%",           // Full width of the container
    minHeight: "20px",       // Taller input
    fontSize: "14px",        // Optional: larger text
    padding: "8px 10px",     // Comfortable padding
    marginTop: "5px"         // Space from label
  }}
/>


  <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
    {taggedEmails.map((email, index) => (
      <span key={index} style={{ backgroundColor: "#eee", padding: "5px", borderRadius: "5px" }}>
        {email}{" "}
        <button onClick={() => removeEmail(index)} style={{ marginLeft: "5px", cursor: "pointer" }}>
          x
        </button>
      </span>
    ))}
  </div>
</div>

	

        <label>Custom Message (optional)</label>
        <textarea className="modern-input" value={customMessage} onChange={(e) => setCustomMessage(e.target.value)}></textarea>
	{success && <p style={{ color: "green" }}>Experience shared successfully!</p>}
        <button type="submit" className="modern-button">Submit</button>
	
      </form>
    </div>
	</div>
  );
}

export default ShareExperiencePage;
